<template>
  <b-modal
    id="WMSModal"
    size="xl"
    content-class="menu-bg-blue-transparent-modal wms-modal"
    body-class="scroll-Container"
    hide-footer
   
    title="Work Management System Reports"
    scrollable
    @show="loadAnsiProjects"
  >
    <div>
      <b-tabs align="center" pills card>
        <b-tab title="Quality" active>
          <b-container>
            <b-row align-v="center">
              <b-col class="col-md-6 offset-md-3 align-self-center">
                <b-form-select
                  v-model="selectedANSI"
                  @change="getSelsets($event)"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      Select Customer *
                    </b-form-select-option>
                  </template>
                  <b-form-select-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :value="customer"
                  >
                    {{ customer.name.substring(0, customer.name.length - 4) }}
                  </b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row
              align-v="center"
              v-if="selsetList"
              class="py-4"
              @change="getReport(selectedSelset)"
            >
              <b-col class="col-md-6 offset-md-3 align-self-center">
                <b-form-select v-model="selectedSelset">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      Select Selset *
                    </b-form-select-option>
                  </template>
                  <b-form-select-option
                    v-for="selset in selsetList"
                    :key="selset.id"
                    :value="selset"
                  >
                    {{ selset.selset }}
                  </b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
          </b-container>
          <h5 v-if="reportRows.length > 0">PART NUMBER : {{ partNumber }}</h5>
          <vue-bootstrap4-table
            v-if="selectedSelset"
            :rows="reportRows"
            :columns="reportColumns"
            :config="config"
            :classes="classes"
          >
          </vue-bootstrap4-table>
        </b-tab>
      </b-tabs>
    </div>
  </b-modal>
</template>
<style>
.wms-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.wms-modal table { color: #063c6d !important; text-shadow: none !important; }
.wms-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.wms-modal thead th a,
.wms-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.wms-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.wms-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.wms-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.wms-modal .footer-pagination-row td,
.wms-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
.wms-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.65);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.3);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: background 0.15s;
}
.wms-modal .nav-pills .nav-link.active {
  background: #063c6d !important;
  color: #fff !important;
  border-color: #063c6d !important;
}
</style>

<script>
import axios from 'axios'
import VueBootstrap4Table from 'vue-bootstrap4-table'
export default {
  name: 'MMP_WmsSelectModal',
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      // Customers are the Customer ANSIs from the database
      customers: [],
      selectedANSI: null,
      selsetList: null,
      selectedSelset: null,
      apiUrl: null,
      partNumber: null,
      reportRows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      },
      reportColumns: [
        {
          label: 'Segment Id',
          name: 'segment_id',
          sort: true
        },
        {
          label: 'Total Review Time',
          name: 'review_time',
          sort: true
        },
        {
          label: 'Technician',
          name: 'technician',
          sort: true
        },
        {
          label: 'Review Date',
          name: 'review_date',
          sort: true
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        per_page: 50,
        show_refresh_button: false,
        show_reset_button: false
      }
    }
  },
  methods: {
    loadAnsiProjects() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/projects/ProjectIdForANSI', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.customers = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    getSelsets(customer) {
      this.selectedSelset = null
      this.reportRows = []
      this.apiUrl = customer.api_url
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/' + this.apiUrl + '/getAllSelsets',
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.selsetList = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    getReport(selectedSelset) {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              '/getAnsiTimeLine',
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: selectedSelset.selset
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.partNumber =
                content.rowCount > 0 ? content.rows[0].partnumber : null
              this.reportRows = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }
}
</script>
